import React from 'react';
import { Modal } from '../../Modal';
import { Button } from '../../Button';
import PolIcon from '../../../assets/icons/main/polCoin.svg';
import { useTranslation } from 'react-i18next';

export const BuyWithOptionals = ({
  isOpened,
  onClose,
  onBuyWithWeekly,
  onBuyOnlyLevel,
  totalPriceLevel,
  totalPriceWithWeekly,
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpened={isOpened} onClose={onClose}>
      <div className="flex flex-col items-start justify-start space-y-[2.4rem] w-[52rem] p-[4rem] modal-styles lg:w-full lg:px-[2rem] lg:rounded-none lg:rounded-t-[2rem] lg:space-y-[2.4rem] lg:border-none">
        <span className="text-white text-[3.2rem] font-600 leading-[4.48rem] tracking-[-0.64px] lg:text-[2.4rem] lg:leading-[3.36rem] lg:tracking-[-0.48px]">
          {t('dashboard.programs.buyWithOptionals.title')}
        </span>
        <p className="text-white-500 text-[1.6rem] font-400 leading-[2.24rem] lg:text-[1.4rem] lg:leading-[1.96rem]">
          {t('dashboard.programs.buyWithOptionals.description')}
        </p>
        <div className="flex items-center space-x-[1.2rem] w-full lg:flex-col lg:space-y-[1.2rem] lg:space-x-0">
          <Button onClick={onBuyWithWeekly} type="purple" className="h-[4.8rem] w-full rounded-[1.2rem]">
            <div className="flex flex-col items-center justify-center text-[1.6rem] font-500 leading-[2.24rem] text-white lg:text-[1.4rem] lg:leading-[1.96rem] space-y-[0.2rem]">
              <span className="text-[1.3rem] font-500 leading-[1.6rem]">
                {t('dashboard.programs.buyWithOptionals.buyWithWeekly')}
              </span>
              <div className="flex items-center justify-center space-x-[0.2rem] text-[1.2rem] font-500 leading-[1.5rem]">
                {totalPriceWithWeekly} <img className="w-[1.6rem] h-[1.6rem] ml-[0.4rem]" src={PolIcon} />
              </div>
            </div>
          </Button>
          <Button onClick={onBuyOnlyLevel} type="black" className="h-[4.8rem] w-full rounded-[1.2rem]">
            <div className="flex flex-col items-center justify-center text-[1.6rem] font-500 leading-[2.24rem] text-white lg:text-[1.4rem] lg:leading-[1.96rem] space-y-[0.2rem]">
              <span className="text-[1.3rem] font-500 leading-[1.6rem]">
                {t('dashboard.programs.buyWithOptionals.buyOnlyLevel')}
              </span>
              <div className="flex items-center justify-center space-x-[0.2rem] text-[1.2rem] font-500 leading-[1.5rem]">
                {totalPriceLevel} <img className="w-[1.6rem] h-[1.6rem] ml-[0.4rem]" src={PolIcon} />
              </div>
            </div>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
